export interface PostalLocalityMaskConfig {
  mask: string;
  slotChar: string;
  placeholder: string;
}

export const POSTAL_LOCALITY_MASK_BY_COUNTRY: Record<string, PostalLocalityMaskConfig> = {
  BE: {
    mask: '9999 - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '5000 - Namur',
  },
  FR: {
    mask: '99999 - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '75008 - Paris',
  },
  CH: {
    mask: '9999 - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '1009 - Pully',
  },
  DE: {
    mask: '99999 - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '10115 - Berlin',
  },
  LU: {
    mask: '9999 - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '1616 - Luxembourg',
  },
  NL: {
    mask: '9999 aa - aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    slotChar: ' ',
    placeholder: '1234 AB - Amsterdam',
  },
};
